import React, { useCallback, useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'react-toastify';
import { SubmitHandler } from 'react-hook-form';
import { ChecklistDetailQueryResponse } from '@area-restrita/api-client/model/checklistDetailQueryResponse';
import { useUpdateChecklist } from '@area-restrita/api-client/endpoints/hang-tag/hang-tag.gen';

import {
  ICheckList,
  checkListSchema,
} from '../../components/CheckListForm/schema';
import EditCheckListView from './view';

interface IProps {
  checkList: ChecklistDetailQueryResponse;
}

const EditCheckList: React.FC<IProps> = ({ checkList }) => {
  const defaultValues = useMemo(
    () => checkListSchema.parse(checkList),
    [checkList],
  );

  const navigate = useNavigate();

  const updateChecklist = useUpdateChecklist({
    mutation: {
      onSuccess: () => {
        toast.success('Checklist atualizado com sucesso');
        navigate({ to: '/settings/hang-tag/check-list' });
      },
      onError: () => {
        toast.error('Erro ao atualizar o checklist');
      },
    },
  });

  const handleSubmit = useCallback<SubmitHandler<ICheckList>>(
    (data) => updateChecklist.mutateAsync({ id: checkList.id, data }),
    [updateChecklist, checkList.id],
  );

  return (
    <EditCheckListView defaultValues={defaultValues} onSubmit={handleSubmit} />
  );
};

export default EditCheckList;
